import { render, staticRenderFns } from "./healthRecordList.vue?vue&type=template&id=193d4da9&scoped=true"
import script from "./healthRecordList.vue?vue&type=script&lang=js"
export * from "./healthRecordList.vue?vue&type=script&lang=js"
import style0 from "./healthRecordList.vue?vue&type=style&index=0&id=193d4da9&prod&lang=less&scoped=scoped"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "193d4da9",
  null
  
)

export default component.exports